module.exports = __webpack_public_path__ + "static/media/img3-1.0cdc318e.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pina/nutricheck_suelo/CA/img3-1.png
// module id = 2333
// module chunks = 3